import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import type { BBQSubmission } from '../App';
import Pflicht from './Pflicht';

interface PaymentProps {
  onNext: (data: BBQSubmission) => void;
  onPrev: () => void;
  loading: boolean;
}

export default function Payment({ onNext, onPrev, loading }: PaymentProps) {
  const { register, watch, handleSubmit } = useFormContext<BBQSubmission>();
  const invoiceAddress = watch('useInvoice');
  const payment = watch('payment');

  return (
    <form style={{ minHeight: 400 }} onSubmit={handleSubmit(onNext)}>
      <h2 className={'headline'}>Zahlungsart wählen</h2>

      <input
        type="radio"
        value={'Per Rechnung'}
        className={'radio tw:w-full tw:mt-8'}
        data-label={'Per Rechnung bezahlen'}
        required
        {...register('payment')}
      />
      <input
        type="radio"
        value={'Bar vor Ort'}
        className={'radio tw:w-full tw:mt-3'}
        data-label={'Bar vor Ort zahlen'}
        required
        {...register('payment')}
      />
      <input
        type="radio"
        value={'Gutschein oder Rabattcode'}
        className={'radio tw:w-full tw:mt-3'}
        data-label={'Gutschein oder Rabattcode eintragen'}
        required
        {...register('payment')}
      />
      {payment === 'Gutschein oder Rabattcode' ? (
        <input
          {...register('discountCode')}
          placeholder={'Code*'}
          className={'text-field tw:mt-3 tw:w-full'}
          required
        />
      ) : null}

      <label
        className={'tw:flex tw:gap-3 tw:items-center tw:mt-6 tw:text-left '}>
        <input
          {...register('useInvoice')}
          checked={invoiceAddress}
          className={'checkbox'}
          type={'checkbox'}
        />
        <span className={'tw:font-bold tw:select-none'}>
          Abweichende Rechnungsadresse
        </span>
      </label>
      {invoiceAddress ? (
        <div
          className={
            'tw:grid tw:grid-cols-1 tw:sm:grid-cols-2 tw:gap-4 tw:mt-4'
          }>
          <input
            className={'text-field'}
            {...register('invoice.firstName')}
            placeholder={'Vorname*'}
            required
            autoComplete={'shipping given-name'}
          />
          <input
            className={'text-field'}
            {...register('invoice.lastName')}
            placeholder={'Nachname*'}
            required
            autoComplete={'shipping family-name'}
          />
          <input
            className={'text-field'}
            {...register('invoice.company')}
            placeholder={'Firma'}
            autoComplete={'shipping organization'}
          />
          <input
            className={'text-field'}
            {...register('invoice.street')}
            placeholder={'Straße und Hausnummer*'}
            required
            autoComplete={'shipping address-line1'}
          />
          <input
            className={'text-field'}
            {...register('invoice.zip')}
            placeholder={'Postleitzahl*'}
            required
            autoComplete={'shipping postal-code'}
          />
          <input
            className={'text-field'}
            {...register('invoice.city')}
            placeholder={'Ort*'}
            required
            autoComplete={'shipping address-level2'}
          />
        </div>
      ) : null}

      <div
        className={
          'tw:flex tw:max-sm:flex-col-reverse tw:gap-4 tw:items-center tw:justify-center tw:mt-8'
        }>
        <button onClick={onPrev} className={'button'} type={'button'}>
          Zurück
        </button>
        <button className={'button tw:max-w-[400px]'}>
          {loading ? '...' : 'Buchung zahlungspflichtig abschließen'}
        </button>
      </div>

      <Pflicht />
    </form>
  );
}
